module.exports = __webpack_public_path__ + "static/media/partly_cloudy.28fc89e8.svg";